/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { linkToQueryDetail } from 'util/appUtils';
import { useDispatch, useSelector } from 'react-redux';
import { getRelatedQueriesByProduct } from 'actions';
import AnalyticTable from 'components/kea/tables/AnalyticTable';
import CardContainerSmall from 'components/kea/CardContainerSmall';
import { useLocalizedMessage } from 'util/useLocalizedMessage';

const RelatedQueries = ({ productId }) => {
  const localizeMessage = useLocalizedMessage();
  const dispatch = useDispatch();
  const { analytics: { search, timeframe }, app: { currentShop } } = useSelector((str) => str);
  const { relatedQueriesByProduct: { isFetching, data, error } } = search;

  useEffect(() => {
    dispatch(getRelatedQueriesByProduct(currentShop, timeframe, productId));
  }, [timeframe, productId]);

  const headCells = [
    {
      id: 'query',
      numeric: false,
      label: localizeMessage('analytics.table.query'),
      sortKey: 'queryText',
    },
    { id: 'count', numeric: true, label: localizeMessage('analytics.table.searches') },
  ];

  const sortDesc = (a, b) => Number(b.count) - Number(a.count);
  const attachLinkToArray = (e) => ({
    ...e,
    queryText: e.query,
    query: linkToQueryDetail(currentShop, e.query),
  });
  const paginationOptions = {
    rowsPerPageList: [10],
    initRowsPerPage: 10,
  };

  return (
    <CardContainerSmall
      headerId="catalog.product.related.queries"
      error={error}
      isFetching={isFetching}
    >
      <AnalyticTable
        paginationOptions={paginationOptions}
        rows={data.sort(sortDesc).map(attachLinkToArray)} // .slice(0, 5)
        headCells={headCells}
        orderById="count"
        emptyMessageId="analytics.product.relatedQueries.empty"
      />
    </CardContainerSmall>
  );
};

export default RelatedQueries;
